import { PrizmLanguageColumnSettings } from '../../interfaces';

export const PRIZM_ENGLISH_COLUMN_SETTINGS: PrizmLanguageColumnSettings = {
  columnSettings: {
    title: 'Table Settings',
    subTitle: 'List Title',
    resetBtn: 'Reset',
    showAllBtn: 'Show All',
    cancelBtn: 'Cancel',
    saveBtn: 'Save',
    fixHeaderToggle: 'Fix header on scroll',
    stickyLeft: 'Fixed Columns on the Left',
    mainColumns: 'Columns',
    stickyRight: 'Fixed Columns on the Right',
    dropzone: 'Drag column here',
    disabledHint: 'Cannot hide the last column',
  },
};
